'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterPopup = exports.CLASS_POPUP_OPEN = exports.POPUP_COOKIE = exports.NEWSLETTER_SUBMIT = exports.NEWSLETTER_UNDERLAY = exports.POPUP_DELAY_DATA = exports.CLOSE_SELECTOR = exports.POPUP_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _ShopifySection2 = require('./../../sections/ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-newsletter-popup]'; /*
                                                                                  *  Newsletter Pop-up
                                                                                  *    Provides scripts for the newsletter pop-up
                                                                                  *
                                                                                  *  Version:
                                                                                  *    1.0.0 - 2020/06/10
                                                                                  */

var POPUP_SELECTOR = exports.POPUP_SELECTOR = '[data-newsletter-popup-wrapper]';
var CLOSE_SELECTOR = exports.CLOSE_SELECTOR = '[data-newsletter-popup-close]';
var POPUP_DELAY_DATA = exports.POPUP_DELAY_DATA = 'data-newsletter-popup-delay';
var NEWSLETTER_UNDERLAY = exports.NEWSLETTER_UNDERLAY = '[data-newsletter-popup-underlay]';
var NEWSLETTER_SUBMIT = exports.NEWSLETTER_SUBMIT = '[data-newsletter-submit]';
var POPUP_COOKIE = exports.POPUP_COOKIE = 'hide-popup';
var CLASS_POPUP_OPEN = exports.CLASS_POPUP_OPEN = 'is-popup-open';

var NewsletterPopup = exports.NewsletterPopup = function (_ShopifySection) {
  (0, _inherits3.default)(NewsletterPopup, _ShopifySection);

  function NewsletterPopup(container) {
    (0, _classCallCheck3.default)(this, NewsletterPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewsletterPopup.__proto__ || Object.getPrototypeOf(NewsletterPopup)).call(this, container));

    _this.popupUnderlay = container.find(NEWSLETTER_UNDERLAY);
    _this.popupTargets = [container, _this.popupUnderlay, (0, _jquery2.default)('html,body')];
    _this.delay = parseInt(container.attr(POPUP_DELAY_DATA));

    container.on('click touch', CLOSE_SELECTOR, function (e) {
      return _this.onCloseClick(e);
    });
    container.on('click', NEWSLETTER_SUBMIT, function () {
      return _this.addCookie();
    });
    container.on('click', NEWSLETTER_UNDERLAY, function (e) {
      return _this.closeNewsletterPopup(e);
    });

    _this.onPopupCookie();
    return _this;
  }

  (0, _createClass3.default)(NewsletterPopup, [{
    key: 'onPopupCookie',
    value: function onPopupCookie() {
      var _this2 = this;

      if (_jsCookie2.default.get(POPUP_COOKIE)) return;
      if (this.container.length) {
        console.log('Attempting to Pop');
        // add 1 to the delay in-case the delay setting is set to zero
        var popupDelay = (this.delay + 1) * 1000;
        setTimeout(function () {
          _this2.onOpenNewsletterPopup();
        }, popupDelay);
      }
    }
  }, {
    key: 'onCloseClick',
    value: function onCloseClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.closeNewsletterPopup();
    }
  }, {
    key: 'onOpenNewsletterPopup',
    value: function onOpenNewsletterPopup() {
      this.popupTargets.forEach(function (e) {
        return e.addClass(CLASS_POPUP_OPEN);
      });
    }
  }, {
    key: 'addCookie',
    value: function addCookie() {
      _jsCookie2.default.set(POPUP_COOKIE, true, { expires: 30 });
    }
  }, {
    key: 'closeNewsletterPopup',
    value: function closeNewsletterPopup() {
      this.popupTargets.forEach(function (e) {
        return e.removeClass(CLASS_POPUP_OPEN);
      });
      this.addCookie();
    }
  }, {
    key: 'cancelEvent',
    value: function cancelEvent(e) {
      e.preventDefault(), e.stopPropagation();
      return true;
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      if (!this.container.hasClass(CLASS_POPUP_OPEN)) return; //Not visible?
      var check = this.container.find(e.target);
      if (check.length) return;
      this.cancelEvent(e);
      this.closeNewsletterPopup();
    }
  }]);
  return NewsletterPopup;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, NewsletterPopup);